import { render, staticRenderFns } from "./HomeNotes.vue?vue&type=template&id=50e069cf"
import script from "./HomeNotes.vue?vue&type=script&lang=js"
export * from "./HomeNotes.vue?vue&type=script&lang=js"
import style0 from "./HomeNotes.vue?vue&type=style&index=0&id=50e069cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports